import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import Icon from '@components/Icon'
import { renderToStaticMarkup } from 'react-dom/server'
import { SIZES } from '../constants'
import Form from '@components/Form'
import { cloneDeep } from 'lodash'
import { uploadFile } from '@helpers/api'
import { nanoid } from 'nanoid'
import { File as FileIcon } from '@components/Svg/SVGIcons'

export class AttachmentTool {
  /**
   * Constructor
   * @param {*} blockConfig
   */
  constructor(blockConfig) {
    // Initial data
    this.data = blockConfig.data ? blockConfig.data : {}
    this.data.id = blockConfig.data.id ? blockConfig.data.id : nanoid()
  }

  /**
   * Toolbox view
   */
  static get toolbox() {
    return {
      title: 'Dokument',
      icon: renderToStaticMarkup(<Icon icon={'File'} />),
    }
  }

  /**
   * Set state
   * @param {*} state
   */
  setState(state) {
    this.data = cloneDeep(state)
  }

  /**
   * Allow any html in content
   */
  // static get sanitize() {
  //   return true
  // }

  /**
   * Save
   * @returns
   */
  async save() {
    // Add file size error handling
    // var filesize = ((file.size/1024)/1024).toFixed(4)

    let file = this.data?.file

    if (file instanceof File) {
      const url = await uploadFile(this.data.file)

      file = {
        name: this.data.file.name,
        extension: this.data.file.name.split('.')[1],
        url
      }
    }

    return {
      ...this.data,
      file,
    }
  }

  /**
   * Render
   * @returns
   */
  render() {
    // Create holder element
    var div = document.createElement('div')

    createRoot(div).render(<Component
        initialState={this.data}
        handleStateChange={this.setState.bind(this)}
      />
    )

    return div
  }
}

const Component = (props) => {
  const { initialState, handleStateChange } = props
  const [state, setState] = useState(initialState)
  const { id, title = '', preamble = '', file } = state

  useEffect(() => handleStateChange(state), [state])

  const handleFileChange = (e) => {
    e.preventDefault()
    let file = e.target.files[0]

    if (file) {
      setState({
        ...state,
        title: file.name.split('.')[0],
        file: file,
      })
    }
  }

  return (
    <div
      className={
        'bg-lightGrey border border-mediumGrey rounded-sm p-4 my-2'
      }
    >
      <label htmlFor={`file-${id}`} className='flex cursor-pointer pb-2'>
        <div className={'text-primaryGreen'}>
          <FileIcon />
        </div>

        <span className='ml-2'>
          {!file ?
            <span>Välj fil</span>
          :
            <span>{title}</span>
          }
        </span>
      </label>
      <input
        type='file'
        id={`file-${id}`}
        name={`file-${id}`}
        onChange={(e) => handleFileChange(e)}
      />

      <Form.Label htmlFor='preamble'>
        Skriv en text som förklarar hur dokumentet ska användas
      </Form.Label>
      <Form.TextArea
        type='text'
        name='preamble'
        defaultValue={preamble}
        placeholder={'Skriv en text som förklarar hur dokumentet ska användas'}
        onChange={(e) => {
          setState({ ...state, preamble: e.target.value })
        }}
      />
    </div>
  )
}

// export const AttachmentTool = connectToEditorjs(
//   AttachmentsToolComponent,
//   'Dokument',
//   renderToStaticMarkup(<Icon icon={'ClipboardAdd'} />)
// )
